/*
 * Copyright (c) 2022-2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

export const ERROR_LINK_ANOTHER_3RD_PARTY_ACCOUNT = 10200
export const ERROR_CODE_LINK_DELETION_ACCOUNT = 10135
export const ERROR_CODE_TOKEN_EXPIRED = 10196
export const ERROR_USER_BANNED = 10134
